__turbopack_context__.v({
  "container": "header-module-scss-module__yv4L2q__container",
  "title": "header-module-scss-module__yv4L2q__title",
});
